import { DataelementerEnum } from './dataminimering'

export enum Soeketype {
    SAMARBEIDSPARTNER_ARBEIDSTAKER = 'samarbeidspartner_arbeidstaker',
    SAMARBEIDSPARTNER_ARBEIDSSTED = 'samarbeidspartner_arbeidssted',
    ARBEIDSTAKER = 'arbeidstaker',
    ARBEIDSSTED = 'arbeidssted',
}

export enum RapporteringsordningEnum {
    A_ORDNINGEN = 'A-ordningen',
    FOER_A_ORDNINGEN = 'Før a-ordningen',
}

export enum ArbeidsforholdstatusEnum {
    AKTIV = 'Aktiv',
    FREMTIDIG = 'Fremtidig',
    AVSLUTTET = 'Avsluttet',
}

export enum ArbeidsforholdtypeEnum {
    ordinaertArbeidsforhold = 'Ordinært',
    maritimtArbeidsforhold = 'Maritimt',
    frilanserOppdragstakerHonorarPersonerMm = 'Frilanser m.m.',
    forenkletOppgjoersordning = 'Forenklet',
}

type SoekCommon = {
    rapporteringsordning: (keyof typeof RapporteringsordningEnum)[]
    arbeidsforholdstatus: (keyof typeof ArbeidsforholdstatusEnum)[]
    arbeidsforholdtype: (keyof typeof ArbeidsforholdtypeEnum)[]
    dataelementer: (keyof typeof DataelementerEnum)[]
}

export type SoekeRequest = { type: Soeketype } & SoekCommon
type ArbeidstakerSoek = { arbeidstakerId: string }
type ArbeidsstedSoek = { arbeidsstedId: string }

type SamarbeidspartnerSoekeRequest = {
    organisasjonsnummer?: string
    rapporteringsordning: (keyof typeof RapporteringsordningEnum)[]
    arbeidsforholdstatus: (keyof typeof ArbeidsforholdstatusEnum)[]
    arbeidsforholdtype: (keyof typeof ArbeidsforholdtypeEnum)[]
    dataelementer: (keyof typeof DataelementerEnum)[]
}

export type SamarbeidspartnerArbeidstakerSoekeRequest = SamarbeidspartnerSoekeRequest & ArbeidstakerSoek
export type SamarbeidspartnerArbeidsstedSoekeRequest = SamarbeidspartnerSoekeRequest & ArbeidsstedSoek
